// set function parseTime,formatTime to filter
import moment from 'moment';

import { parseTime, formatTime } from '@/utils';
import { round2, format as moneyFormat, add as moneyAdd, sub as moneySub, mul as moneyMul, div as moneyDiv, percent as moneyPercent, compare as moneyCompare, isPositive as moneyIsPositive, isZero as moneyIsZero, abs as moneyAbs, toCents, fromCents } from '@/utils/money';

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' },
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

function uppercaseFirst(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

function formatDate(date) {
  return moment(date).format('DD/MM/YYYY');
}

// Display-only formatter. Always shows 2 decimal places (e.g. "0.50" not "0.5").
// `round: true` rounds the value to 2dp before formatting — useful when
// the input came from a float computation that may have introduced drift.
function formateNumber(number, { round = false } = {}) {
  const value = round ? round2(number) : number;
  return moneyFormat(value);
}

// Round a value to 2 decimal places. Returns a Number (not a string)
// so the result can be used directly in further arithmetic.
function numberRound(number) {
  return round2(number);
}

export {
  formatDate,
  formateNumber,
  numberRound,
  uppercaseFirst,
  toThousandFilter,
  numberFormatter,
  timeAgo,
  pluralize,
  parseTime,
  formatTime,
  // Money helpers (safe decimal arithmetic — use these for calculations,
  // not parseFloat or arithmetic operators on money values).
  moneyAdd,
  moneySub,
  moneyMul,
  moneyDiv,
  moneyPercent,
  moneyCompare,
  moneyIsPositive,
  moneyIsZero,
  moneyAbs,
  round2,
  moneyFormat,
  toCents,
  fromCents,
}
